// @ts-nocheck

import BookingPlanCard from '../BookingPlanCard/BookingPlanCard';
import { Box } from '@mui/material';
import * as PropTypes from 'prop-types';

/**
 * Functional React component for rendering a custom booking plan options component .
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {string} [props.id] - The ID for the booking plan options component.
 * @param {Array} [props.bookingPlans] - The booking plans.
 * @param {number} [props.tripCapacity] - The trip capacity.
 * @param {boolean} [props.isFullCapacity] - Whether the trip is full capacity.
 *
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the booking plan options component.
 */

const BookingPlan = ({
  id,
  bookingPlans,
  tripCapacity = null,
  isFullCapacity = false,
  isTripDeparted = false,
  usedCapacity = 0,
  showCapacityBanner = false,
  capacityBannerProps = {},
  ...rest
}) => {
  return (
    <Box
      id={id}
      data-testid='booking-plan-options'
      {...rest}
      className='book-now-modal__payment-options book-now-modal___left-panel'
    >
      {showCapacityBanner && capacityBannerProps.BannerComponent && (
        <capacityBannerProps.BannerComponent {...capacityBannerProps} />
      )}
      <div className='book-now-modal__plans-container'>
        {bookingPlans &&
          bookingPlans?.map((bookingPlan) => {
            return (
              <BookingPlanCard
                key={bookingPlan?.tripplanid}
                id={`${bookingPlan?.tripplanid}`}
                data={bookingPlan}
                tripCapacity={tripCapacity}
                allPlans={bookingPlans}
                isFullCapacity={isFullCapacity}
                isTripDeparted={isTripDeparted}
                usedCapacity={usedCapacity}
              />
            );
          })}
      </div>
    </Box>
  );
};

BookingPlan.propTypes = {
  onHandleNext: PropTypes.func,
  bookingPlans: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      depositamount: PropTypes.number,
      depositduedate: PropTypes.string,
      lastbookdate: PropTypes.string,
      maxavailable: PropTypes.number,
      occupancy: PropTypes.number,
      priceperperson: PropTypes.number,
      tripplanid: PropTypes.number,
      title: PropTypes.string,
      selectedQuantity: PropTypes.number,
      hideTotalBreakdown: PropTypes.bool
    })
  ),
  onHandleCancel: PropTypes.func,
  id: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool,
  tripCapacity: PropTypes.number,
  isFullCapacity: PropTypes.bool,
  isTripDeparted: PropTypes.bool,
  usedCapacity: PropTypes.number,
  showCapacityBanner: PropTypes.bool,
  capacityBannerProps: PropTypes.object
};
export default BookingPlan;
